import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {map, take} from 'rxjs/operators';

import {AiChatService} from '../../services/ai-chat.service';

@Component({
  selector: 'ai-chat-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {
  @Input() fileId: string;

  url: SafeUrl;
  error: string;

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private aiChatService: AiChatService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.loadImage();
  }

  private loadImage() {
    if (!this.fileId) {
      this.error = this.translate.instant('AI_CHAT.FILE_GENERATION_FAILED');
      return;
    }

    this.aiChatService
      .getFileContent(this.fileId)
      .pipe(
        take(1),
        map(blob => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob)))
      )
      .subscribe({
        next: url => {
          this.url = url;
          this.cdr.detectChanges();
        },
        error: async response => {
          const blobError = response.error as Blob;
          const result = await blobError.text().then(JSON.parse);

          this.error = result.error;
          this.cdr.detectChanges();
        }
      });
  }
}
